module.exports = __webpack_public_path__ + "img/fondo-becas_03.aec70bdb.jpg";